export const FORM_TYPES = {
  INSURANCE_ONLY: 'INSURANCE_ONLY_FORM',
  NONE: 'NONE',
} as const
